import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatDate, formatCurrency } from '@ajaibid/utils';
import { Button, colors } from '@ajaibid/components';
import { deleteMfAutoOrder } from '@services/api/platform/mfAutoOrder';

import useEventTracker from '../tracker';
import useMfAutoOrder from './useMfAutoOrder';

/**
 * @returns {import('@ajaibid/components').TableColumnDefinition[]}
 */
function useColumns() {
  const navigate = useNavigate();
  const { refetch } = useMfAutoOrder();
  const { eventClickUpdateMFAutoOrder } = useEventTracker();

  const [isModalDelete, setIsModalDelete] = useState(false);
  const [id, setId] = useState(0);
  const [index, setIndex] = useState(0);

  const removeMfAutoOrder = useCallback(
    async (payload) => {
      await deleteMfAutoOrder(payload);
      setIsModalDelete(false);
      refetch();
    },
    [deleteMfAutoOrder, refetch]
  );

  const columns = [
    {
      path: '',
      name: 'Periode',
      size: 120,
      renderCell: ({ row }) => {
        return (
          <div>
            <span>{row.original.start_duration} - </span>
            <p style={{ margin: 0 }}>
              {row.original.end_duration}({row.original.frequency} Bln)
            </p>
          </div>
        );
      },
    },
    {
      path: 'frequency',
      name: 'Durasi',
      size: 80,
      renderCell: (ctx) => {
        return <span>{ctx.getValue()} Bulan</span>;
      },
    },
    {
      path: 'name',
      name: 'Aset',
      size: 160,
      renderCell: (ctx) => {
        return <div style={{ color: colors.AJAIB_BLUE_5, fontWeight: 700 }}>{ctx.getValue()}</div>;
      },
    },
    {
      path: 'amount',
      name: 'Nilai Transaksi',
      size: 100,
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
    },
    {
      path: '',
      name: 'Setor Berikutnya',
      size: 100,
      renderCell: ({ row }) => {
        const isCompleted = row.original.is_completed;
        const nextPayment = row.original.next_run;
        return <span>{isCompleted ? '-' : formatDate(nextPayment)}</span>;
      },
    },
    {
      path: 'is_completed',
      name: 'Status',
      size: 80,
      renderCell: (ctx) => {
        const isCompleted = ctx.getValue();
        return <span>{isCompleted ? 'Telah Berakhir' : 'Sedang Berjalan'}</span>;
      },
    },
    {
      path: 'id',
      name: '',
      action: true,
      renderCell(ctx) {
        const getId = ctx.getValue();
        const isCompleted = ctx.row.original.is_completed;
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {!isCompleted && (
              <Button
                variant="secondary"
                style={{ marginRight: 12 }}
                onClick={() => {
                  navigate({
                    pathname: `/home/reksadana/${getId}/setor`,
                    search: '?isEdit=true',
                  });
                  eventClickUpdateMFAutoOrder();
                }}
              >
                Ubah
              </Button>
            )}
            <Button
              variant="danger-outline"
              onClick={() => {
                setIsModalDelete(true);
                setId(getId);
                setIndex(ctx.row.id);
              }}
            >
              Hapus
            </Button>
          </div>
        );
      },
    },
  ];

  return { columns, id, index, isModalDelete, setIsModalDelete, removeMfAutoOrder };
}

export default useColumns;
